import React, { useState, useEffect } from 'react';
import axios from 'axios';

// StatusBadge component
const StatusBadge = ({ statusJson }) => {
    try {
        const statusData = JSON.parse(statusJson);
        if (statusData.status === true && statusData.data.status === 'success') {
            return <span style={{ color: '#16A34A', fontWeight: '600' }}>Success</span>;
        }
        if (statusData.status === true && statusData.data.status === 'pending') {
            return <span style={{ color: '#CA8A04', fontWeight: '600' }}>Pending</span>;
        }
    } catch (e) {}
    return <span style={{ color: '#DC2626', fontWeight: '600' }}>Failed</span>;
};

const RefundsPage = () => {
    const [searchTerm, setSearchTerm] = useState('');
    const [refunds, setRefunds] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const API_URL = 'https://installmentzone.com/api/paystack/refunds.php';

        axios.get(API_URL)
            .then(response => {
                if (response.data && response.data.success) {
                    setRefunds(response.data.data);
                } else {
                    setError(response.data.message || 'Failed to fetch refund data.');
                }
            })
            .catch(err => {
                setError('Could not connect to the server or an error occurred.');
                console.error("API Error:", err);
            })
            .finally(() => setLoading(false));
    }, []);

    const filteredRefunds = refunds.filter(refund =>
        refund.phone.includes(searchTerm) ||
        (refund.reference && refund.reference.toLowerCase().includes(searchTerm.toLowerCase()))
    );

    return (
        <div
            style={{
                minHeight: '100vh',
                padding: '40px 20px',
                background: 'linear-gradient(135deg, #1E3A8A, #3B82F6, #60A5FA)',
                fontFamily: 'Segoe UI, sans-serif',
                color: '#fff',
                overflowY: 'auto',
                WebkitOverflowScrolling: 'touch',
                scrollBehavior: 'smooth',
            }}
        >
            <div
                style={{
                    background: 'rgba(255, 255, 255, 0.15)',
                    padding: '30px',
                    borderRadius: '15px',
                    maxWidth: '1200px',
                    margin: '0 auto',
                    boxShadow: '0 6px 15px rgba(0,0,0,0.2)',
                    backdropFilter: 'none',
                }}
            >
                <h1 style={{ textAlign: 'center', fontSize: '28px', fontWeight: '600', marginBottom: '10px' }}>
                    Unregistered Payments & Refunds
                </h1>
                <p style={{ textAlign: 'center', marginBottom: '30px' }}>
                    This log shows payments from unregistered phone numbers that were automatically refunded.
                </p>

                {/* Search input */}
                <div style={{ marginBottom: '20px', textAlign: 'center' }}>
                    <input
                        type="text"
                        placeholder="Search by phone or transaction reference..."
                        value={searchTerm}
                        onChange={e => setSearchTerm(e.target.value)}
                        style={{
                            padding: '10px 15px',
                            borderRadius: '8px',
                            border: 'none',
                            width: '100%',
                            maxWidth: '400px',
                        }}
                    />
                </div>

                {/* Error message */}
                {error && (
                    <div style={{
                        padding: '15px',
                        marginBottom: '20px',
                        background: 'rgba(220, 38, 38, 0.15)',
                        borderRadius: '10px',
                        textAlign: 'center',
                        color: '#fff'
                    }}>
                        <strong>Error:</strong> {error}
                    </div>
                )}

                {/* Table */}
                <div style={{ overflowX: 'auto', willChange: 'transform' }}>
                    <table style={{
                        width: '100%',
                        borderCollapse: 'collapse',
                        background: 'rgba(255, 255, 255, 0.9)',
                        borderRadius: '10px',
                        overflow: 'hidden',
                        color: '#1E293B',
                        tableLayout: 'fixed',
                    }}>
                        <thead>
                            <tr style={{ background: '#1E3A8A', color: '#fff' }}>
                                <th style={{ padding: '14px', textAlign: 'left' }}>Date & Time</th>
                                <th style={{ padding: '14px', textAlign: 'left' }}>Phone Number</th>
                                <th style={{ padding: '14px', textAlign: 'right' }}>Amount</th>
                                <th style={{ padding: '14px', textAlign: 'left' }}>Transaction Reference</th>
                                <th style={{ padding: '14px', textAlign: 'left' }}>Refund Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                [...Array(5)].map((_, i) => (
                                    <tr key={i}>
                                        <td className="skeleton-cell"><div></div></td>
                                        <td className="skeleton-cell"><div></div></td>
                                        <td className="skeleton-cell"><div></div></td>
                                        <td className="skeleton-cell"><div></div></td>
                                        <td className="skeleton-cell"><div></div></td>
                                    </tr>
                                ))
                            ) : (
                                filteredRefunds.length > 0 ? (
                                    filteredRefunds.map((refund, index) => (
                                        <tr
                                            key={index}
                                            style={{
                                                background: index % 2 === 0 ? '#F8FAFC' : '#FFFFFF',
                                                borderBottom: '1px solid #E5E7EB',
                                                transition: 'background 0.2s ease',
                                            }}
                                        >
                                            <td style={{ padding: '12px' }}>{refund.dateTime}</td>
                                            <td style={{ padding: '12px' }}>{refund.phone}</td>
                                            <td style={{
                                                padding: '12px',
                                                textAlign: 'right',
                                                fontWeight: '500',
                                                color: '#0F766E'
                                            }}>
                                                GH₵ {parseFloat(refund.amount).toFixed(2)}
                                            </td>
                                            <td style={{ padding: '12px' }}>{refund.reference}</td>
                                            <td style={{ padding: '12px' }}>
                                                <StatusBadge statusJson={refund.status} />
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="5" style={{ padding: '12px', textAlign: 'center' }}>
                                            {refunds.length > 0 ? "No refunds match your search." : "No refund events found in the log."}
                                        </td>
                                    </tr>
                                )
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default RefundsPage;
